const actions = {
	SET_DASHBOARD_HEADER: "SET_DASHBOARD_HEADER",
	SET_SELETED_TAB: "SET_SELETED_TAB",
	SET_customer: "SET_customer"
};

export default actions;
